import { useContext, useEffect, useRef } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { AuthContext } from "../context/AuthContext";

const TawkChat = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const tawkMessengerRef = useRef();

  useEffect(() => {
    if(window.Tawk_API){
      const hasValue = Object.keys(window.Tawk_API).length !== 0;
      if (isAuthenticated) {
        if (hasValue) {
          window.Tawk_API.shutdown();
        }
      } else {
        if (hasValue) {
          window.Tawk_API.showWidget();
        }
      }
    }
  }, [isAuthenticated]);

  return (
    <>
      {!isAuthenticated && (
        <TawkMessengerReact
          propertyId="658991e070c9f2407f833a06"
          widgetId="1higm3lt3"
          ref={tawkMessengerRef}
        />
      )}
    </>
  );
};

export default TawkChat;
